const userdietorder = {
  getlist: 'userdietorder/getlist',
  changestatus: 'userdietorder/change-status',
  confirmpay: 'userdietorder/confirm-pay',
}
export default userdietorder
